import { ALARM_INTERVAL_UNITS, alarmIntervalToSeconds } from './alarm-interval';
import { MAX_DATA_WINDOW_DAYS, MAX_DATA_WINDOW_SECONDS, dataWindowUnitToSeconds } from '../filterParameterMapping';

export const MAX_RULE_NAME_LENGTH = 255;
export const MAX_DESCRIPTION_LENGTH = 500;
export const MAX_OWNER_LENGTH = 255;
export const MAX_ALARM_INTEGER = 2147483647;

const isEmpty = value => value == null || String(value).trim() === '';
const characterCount = value => Array.from(value || '').length;

export const getAlarmRuleCriteriaErrors = form => {
  const threshold = Number(form.alarmThresholdCount);
  const intervalSeconds = alarmIntervalToSeconds(form.alarmIntervalValue, form.alarmIntervalUnit);
  return {
    alarmThresholdCount: isEmpty(form.alarmThresholdCount) ? 'Required.'
      : !Number.isInteger(threshold) || threshold < 1 || threshold > MAX_ALARM_INTEGER
        ? 'Enter a whole number from 1 to 2,147,483,647.' : '',
    alarmIntervalValue: isEmpty(form.alarmIntervalValue) ? 'Required.'
      : !ALARM_INTERVAL_UNITS.some(unit => unit.value === form.alarmIntervalUnit)
        || !Number.isInteger(intervalSeconds) || intervalSeconds < 1 || intervalSeconds > MAX_ALARM_INTEGER
        ? 'Enter a positive duration in whole seconds.' : '',
  };
};

export const getAlarmRuleFieldErrors = form => ({
  ruleName: !form.ruleName?.trim() ? 'Required.'
    : characterCount(form.ruleName) > MAX_RULE_NAME_LENGTH ? `Maximum ${MAX_RULE_NAME_LENGTH} characters.` : '',
  description: characterCount(form.description) > MAX_DESCRIPTION_LENGTH ? `Maximum ${MAX_DESCRIPTION_LENGTH} characters.` : '',
  ownerText: characterCount(form.ownerText) > MAX_OWNER_LENGTH ? `Maximum ${MAX_OWNER_LENGTH} characters.` : '',
  ...getAlarmRuleCriteriaErrors(form),
});

export const getAlarmRuleFormError = form => {
  const errors = getAlarmRuleFieldErrors(form);
  const labels = { ruleName: 'Rule Name', description: 'Description', ownerText: 'Owner', alarmThresholdCount: 'Threshold Count', alarmIntervalValue: 'Within' };
  const field = Object.keys(errors).find(key => errors[key]);
  return field ? `${labels[field]}: ${errors[field]}` : '';
};

// Do not use the general filter fallback: invalid visible input must block rule actions.
export const getAlarmRuleDataWindowSeconds = selection => {
  if (!selection) return NaN;
  if (selection.dataWindowMode === 'date') {
    if (!selection.startDate || !selection.endDate) return NaN;
    return (new Date(selection.endDate).getTime() - new Date(selection.startDate).getTime()) / 1000;
  }
  const value = Number(selection.dataWindowValue);
  if (isEmpty(selection.dataWindowValue) || !Number.isFinite(value) || value <= 0
      || !dataWindowUnitToSeconds[selection.dataWindowMode]) return NaN;
  const unitSeconds = dataWindowUnitToSeconds[selection.dataWindowMode];
  const seconds = selection.dataWindowSeconds != null ? Number(selection.dataWindowSeconds)
    : value * unitSeconds;
  return Math.round(seconds) / unitSeconds === value ? Math.round(seconds) : seconds;
};

export const getAlarmRuleDataWindowError = seconds => {
  if (!Number.isFinite(seconds) || seconds <= 0) return 'Enter a duration greater than zero.';
  if (seconds > MAX_DATA_WINDOW_SECONDS) return `Maximum ${MAX_DATA_WINDOW_DAYS} days.`;
  return Number.isInteger(seconds) ? '' : 'Enter a duration in whole seconds.';
};
